import { render, staticRenderFns } from "./FormFloatingLabel.vue?vue&type=template&id=38be09fc&scoped=true&"
import script from "./FormFloatingLabel.vue?vue&type=script&lang=js&"
export * from "./FormFloatingLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormFloatingLabel.vue?vue&type=style&index=0&id=38be09fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be09fc",
  null
  
)

export default component.exports